'use client'

import { Builder, withChildren } from '@builder.io/react'

import { clickActionInputs } from '@src/hooks/useClickAction/useClickAction.builder'

import { ActionLink } from './ActionLink'

Builder.registerComponent(withChildren(ActionLink), {
  name: 'ActionLink',
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: {
        name: 'Columns',
        options: {
          columns: [{ blocks: [] }],
          space: 20,
          stackColumnsAt: 'tablet',
          reverseColumnsWhenStacked: false,
        },
      },
      responsiveStyles: {
        large: {
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          flexShrink: '0',
          boxSizing: 'border-box',
        },
      },
    },
  ],
  inputs: [...clickActionInputs],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/link-plus.svg',
})
